import lodashGet from 'lodash/get';
import {createSelector} from 'reselect';
import {getCurrentlyViewedAttachments} from './attachments-selectors';

export const getThumbnails = state => state.thumbnails;

export const getThumbnailUrlFromAttachment = (attachment, thumbnails) => {
  const {urn} = attachment;
  const {[urn]: thumbnailData} = thumbnails;
  return lodashGet(thumbnailData, 'attachmentUrl');
};

export const getThumbnailUrlByAttachment = createSelector(
  getThumbnails,
  (state, attachment) => attachment,
  (thumbnails, attachment) => {
    if (!attachment || !thumbnails) {
      return null;
    }
    return getThumbnailUrlFromAttachment(attachment, thumbnails);
  }
);

export const getCurrentlyViewedAttachmentsWithThumbnails = createSelector(
  getCurrentlyViewedAttachments,
  getThumbnails,
  (attachments, thumbnails) => {
    if (!attachments) {
      return null;
    }
    return attachments.map(attachment => {
      if (!attachment || !thumbnails) {
        return null;
      }
      const thumbnailUrl = getThumbnailUrlFromAttachment(attachment, thumbnails);
      return {name: attachment.name, original: thumbnailUrl, thumbnail: thumbnailUrl};
    });
  }
);

export const getGalleryIsOpen = createSelector(
  getCurrentlyViewedAttachmentsWithThumbnails,
  attachments => !!attachments && !!attachments.length
);
